<script setup lang="ts">
import { computed } from "vue";

import { objectiveActions } from "@/action/objectiveActions";
import StatusClassDistributionBar from "@/components/StatusDistribution/StatusClassDistributionBar.vue";
import MenuItemDelimiter from "@/components/menu/MenuItemDelimiter.vue";
import type { BoardWithObjectives } from "@/model/board";
import type { Objective, RAG } from "@/model/objective";
import { useObjectiveStore } from "@/store/objective";
import { useWorkModeStore } from "@/store/workMode";

import ObjectiveLinksChip from "./ObjectiveLinksChip.vue";
import RAGChip from "./RAGChip.vue";

const props = defineProps<{
  objective: Objective;
  board: BoardWithObjectives;
  hasStatusDistribution?: boolean;
  boardScale?: boolean;
}>();

const linkedCardTree = computed(() =>
  useObjectiveStore().linkedCardTree(props.board, props.objective),
);
const isExecutionMode = computed(() => useWorkModeStore().isExecutionMode);

function setRAGValue(rag: RAG) {
  objectiveActions.setRag("modal", props.board.id, props.objective, rag);
}
</script>

<template>
  <RAGChip
    v-if="isExecutionMode"
    :rag="objective.rag"
    :class="boardScale ? 'board-scale' : 'fixed-scale'"
    @update:rag="setRAGValue"
  />
  <MenuItemDelimiter v-if="isExecutionMode" />
  <ObjectiveLinksChip
    :linking-objective="{ type: 'objective', boardId: board.id, id: objective.id }"
    :class="boardScale ? 'board-scale' : 'fixed-scale'"
  />
  <StatusClassDistributionBar
    v-if="hasStatusDistribution && isExecutionMode"
    :value="linkedCardTree.statusDistribution"
    source-item-type="objective"
    :filters="{ boardId: board.id, objectiveId: objective.id }"
    :title="objective.text"
  />
</template>

<style lang="scss" scoped>
.status-distribution {
  height: 1rem;
  width: 30%;
}
</style>
